import { useLiveQuery } from 'dexie-react-hooks'
import { useEffect } from 'react'
import { db } from '../../db/db'
import { isMuted } from '../../lib/channels'
import { setNativeBadge } from '../../native/badge'
import { isNative } from '../../native/native'

/** Mirror the total unread count on the app icon: the Badging API in browsers, the app's own plugin in the app. */
export function useAppBadge(): void {
  const total = useLiveQuery(
    async () =>
      (await db.channels.toArray())
        .filter((c) => c.isMember && !isMuted(c) && c.notify !== 'none')
        .reduce((sum, c) => sum + c.unread, 0),
    [],
    0,
  )
  useEffect(() => {
    if (isNative()) {
      void setNativeBadge(total)
      return
    }
    const nav = navigator as Navigator & {
      setAppBadge?: (n?: number) => Promise<void>
      clearAppBadge?: () => Promise<void>
    }
    if (!nav.setAppBadge) return
    if (total > 0) void nav.setAppBadge(total).catch(() => undefined)
    else void nav.clearAppBadge?.().catch(() => undefined)
  }, [total])
}
